if (!customElements.get('offer-slider')) {
  customElements.define('offer-slider', class OfferSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.wp-offers__grid');
      this.previous = this.querySelector('[data-offer-previous]');
      this.next = this.querySelector('[data-offer-next]');
      this.controls = this.querySelector('.wp-offers__controls');
      if (!this.track || !this.previous || !this.next) return;
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.scrollTo(0);
        else if (event.key === 'End') this.scrollTo(this.track.scrollWidth);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.track.querySelectorAll('.wp-offer-card').forEach((card) => this.observer.observe(card));
      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previous.disabled = this.track.scrollLeft <= 1;
      this.next.disabled = this.track.scrollLeft >= max - 1;
      this.controls.hidden = max <= 1;
    }

    move(direction) {
      const cards = this.track.querySelectorAll('.wp-offer-card');
      if (cards.length < 2) return;
      const step = cards[1].offsetLeft - cards[0].offsetLeft;
      this.scrollTo(this.track.scrollLeft + direction * step);
    }

    scrollTo(left) {
      this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
}
